export default "assets/images/icons/service-cefe6a77.svg";